import { Create, useForm } from "@refinedev/antd";
import { Button, Form, Space } from "antd";
import { v4 as randomId } from "uuid";
import {
  AppImageUploader,
  AppRichText,
  AppTitle,
  EFileTypes,
} from "components";
import { errorNotification, successNotification } from "helpers";
import { MedicineSectionForm } from "../Providers/medicine-section-data-provider";

export const MedicineSection = () => {
  const { formProps, formLoading, saveButtonProps, onFinish } =
    useForm<MedicineSectionForm>({
      resource: "medicine-section",
      action: "edit",
      id: "",
      dataProviderName: "medicineSectionDataProvider",
      redirect: false,
      ...successNotification({
        successData: {
          message: "Главный блок медицины сохранен",
          type: "success",
        },
      }),
      ...errorNotification({}),
    });

  const onSubmit = async (values: MedicineSectionForm) => {
    onFinish(values);
  };

  return (
    <Create
      isLoading={formLoading}
      title={<AppTitle canGoBack>Главный блок медицины</AppTitle>}
      breadcrumb={false}
      headerButtons={<></>}
      footerButtons={null}
      goBack={false}
    >
      <Form {...formProps} layout="vertical" onFinish={onSubmit}>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Form.Item
            name="imageUrl"
            label="Изображение"
            rules={[
              {
                required: true,
                message: "Укажите изображение",
              },
            ]}
          >
            <AppImageUploader
              type="MEDICINE"
              entityId={`${randomId()}`}
              serviceType={EFileTypes.MEDICINE}
              cropperProps={{
                modalTitle: "Редактировать изображение",
              }}
              uploadProps={{
                multiple: false,
                children: "Изображение",
                listType: "picture-card",
              }}
            />
          </Form.Item>

          <Form.Item
            name="description"
            label="Описание"
            rules={[
              {
                required: true,
                message: "Введите описание",
              },
            ]}
          >
            <AppRichText />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={saveButtonProps.loading}
          >
            Сохранить
          </Button>
        </Space>
      </Form>
    </Create>
  );
};
